import { useNavigate } from "react-router-dom"
import { Input, Select } from "antd"
import { BsFillTrashFill, BsPencilSquare } from "react-icons/bs"

import PaginationComponent from "../../../../components/pagination/PaginationComponent"
import Loading from "../../../../components/loading/Loading"
import useRatingQuota from "./useRatingQuota"
import { SearchOutlined } from "@ant-design/icons"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

// ============= CONSTANTS =============
const LIMIT_OPTIONS = [
    { label: 10, value: 10 },
    { label: 25, value: 25 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
]

const RatingQuota = ({
    active,
    project_id,
    payload,
    ratingQuotas,
    handleShow,
    setDeleteID,
    setName,
    setIsRatingQuota,
    pageRatingQuota,
    totalPageRatingQuota,
    changePageRatingQuota,
    setFilterNameUserRatingQuota,
    setFilterLimitRatingQuota,
    onRefresh,
}) => {
    const navigate = useNavigate()
    const {
        handleFileChange,
        postRatingQuota,
        logs,
        loadingPagestate
    } = useRatingQuota()

    const handleDeleteClick = (rq) => {
        handleShow()
        setDeleteID(`${rq.ProjectID}/${rq.BusinessUnitID}`)
        setName(`Rating Quota for ${rq.BusinessUnit.Name}`)
        setIsRatingQuota(true)
    }

    return (
        <div>
            <Loading state={loadingPagestate} />
            
            {!active && (
                <form onSubmit={(e) => {
                    e.preventDefault()
                    postRatingQuota(project_id, onRefresh)
                }}>
                    <input 
                        type="file" 
                        className="form-control" 
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFileChange} 
                    />
                    <div align="right" className="mt-2">
                        <ActionButtonGradient
                            type="submit"
                            variant="primary"
                            children={"Upload File"}
                        />
                    </div>
                </form>
            )}

            {logs && (
                <div className="logs">
                    <p>The following Business Unit ID has an error in the data in the column. Please double check the excel file that you submitted:</p>
                    {logs.map((log, index) => (
                        <p key={index}>{log}</p>
                    ))}
                </div>
            )}
{/* <div style={{ display: 'flex', gap: '12px', marginTop: '32px' }}>
                        <button
                            type="submit"
                            style={{
                                padding: '8px 12px',
                                backgroundColor: '#02B4CC',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                fontSize: '12px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                transform: 'translateY(0)',
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#028A9B';
                                e.target.style.transform = 'translateY(-1px)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#02B4CC';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            {isUpdate ? "Save Changes" : "Create Announcement"}
                        </button>
                    </div> */}
            <div>
                <div className="d-flex justify-content-between align-items-center my-3">
                    <Input 
                        placeholder="Search by business unit name" 
                        allowClear 
                        onChange={setFilterNameUserRatingQuota} 
                        style={{ width: '35%', fontSize: '16px' }}
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                    />
                    <ActionButtonGradient
                        onClick={() => navigate(`/project-list/rating-quota/${payload.ID}`)}
                        variant="success"
                        children={"Create Rating Quota"}
                    />
                </div>
                
                <div className="table-responsive">
                    <table className="table align-items-center">
                        <thead>
                            <tr>
                                <th scope="col" className="text-center">Business Unit</th>
                                <th scope="col" className="text-center">A+ Quota</th>
                                <th scope="col" className="text-center">A Quota</th>
                                <th scope="col" className="text-center">B+ Quota</th>
                                <th scope="col" className="text-center">B Quota</th>
                                <th scope="col" className="text-center">C Quota</th>
                                <th scope="col" className="text-center">D Quota</th>
                                <th scope="col" className="text-center">Remaining (+)</th>
                                <th scope="col" className="text-center">Excess (-)</th>
                                <th scope="col" className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {ratingQuotas?.map((rq, index) => (       
                                <tr key={index}>
                                    <td>{rq.BusinessUnit.Name}</td>
                                    <td className="text-center">{rq.APlusQuota.toFixed(2)}%</td>
                                    <td className="text-center">{rq.AQuota.toFixed(2)}%</td>
                                    <td className="text-center">{rq.BPlusQuota.toFixed(2)}%</td>
                                    <td className="text-center">{rq.BQuota.toFixed(2)}%</td>
                                    <td className="text-center">{rq.CQuota.toFixed(2)}%</td>
                                    <td className="text-center">{rq.DQuota.toFixed(2)}%</td>
                                    <td className="text-center">{rq.Remaining}</td>
                                    <td className="text-center">{rq.Excess}</td>
                                    <td>
                                        <div className="d-flex gap-2 justify-content-center">
                                        <button 
                                            className="btn" 
                                            onClick={() => navigate(`/project-list/rating-quota/${rq.ProjectID}/${rq.BusinessUnitID}`)}    
                                            title="Edit Rating Quota"
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #02B4CC',
                                                backgroundColor: 'transparent',
                                                color: '#02B4CC',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#02B4CC';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#02B4CC';
                                            }}
                                        >
                                            <BsPencilSquare size={14} />
                                            Edit
                                        </button>
                                        <button 
                                            className="btn" 
                                            onClick={() => handleDeleteClick(rq)}   
                                            title="Delete Rating Quota"
                                            style={{
                                                padding: '8px 12px',
                                                borderRadius: '5px',
                                                border: '1px solid #dc3545',
                                                backgroundColor: 'transparent',
                                                color: '#dc3545',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#dc3545';
                                                e.currentTarget.style.color = 'white';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = 'transparent';
                                                e.currentTarget.style.color = '#dc3545';
                                            }}
                                        >
                                            <BsFillTrashFill size={14} />
                                            Delete
                                        </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                
                <div align="right">
                    <Select
                        style={{ marginLeft: "0.5rem" }}
                        defaultValue={10}
                        options={LIMIT_OPTIONS}
                        onChange={setFilterLimitRatingQuota}
                    />
                </div>
                
                <div className="table-responsive">
                    <PaginationComponent
                        current={pageRatingQuota}
                        totalPages={totalPageRatingQuota}
                        navigate={changePageRatingQuota}
                    />
                </div>
            </div>
        </div>
    )
}

export default RatingQuota